// Page matching is deliberately flat; navigation groups are defined in src/navigation.
export default [
  {
    path: '/business-trip/workbench',
    name: '出差概览',
    access: 'business-trips',
    component: '@/modules/business-trip/entries/workbench',
  },
  {
    path: '/business-trip/items',
    name: '出差事项',
    access: 'business-trips',
    component: '@/modules/business-trip/entries/items',
  },
  {
    path: '/business-trip/trip',
    name: '出差计划',
    access: 'business-trips',
    component: '@/modules/business-trip/entries/trip',
  },
  {
    path: '/business-trip/analysis',
    name: '出差分析',
    access: 'business-trips',
    component: '@/modules/business-trip/entries/analysis',
  },
  {
    path: '/business-trip/trip/create',
    name: '新建出差',
    access: 'business-trips',
    component: '@/modules/business-trip/entries/create',
    hideInMenu: true,
    parentKeys: ['/business-trip/trip'],
  },
  {
    path: '/business-trip/trip/activity/:activityUuid',
    name: '出差活动',
    access: 'business-trips',
    component: '@/modules/business-trip/entries/activity',
    hideInMenu: true,
    parentKeys: ['/business-trip/trip'],
  },
  {
    path: '/business-trip/trip/:tripPlanId/schedule',
    name: '行程编排',
    access: 'business-trips',
    component: '@/modules/business-trip/entries/schedule',
    hideInMenu: true,
    parentKeys: ['/business-trip/trip'],
  },
  {
    path: '/business-trip/trip/:tripPlanId',
    name: '出差详情',
    access: 'business-trips',
    component: '@/modules/business-trip/entries/detail',
    hideInMenu: true,
    parentKeys: ['/business-trip/trip'],
  },
  { path: '/business-trip', redirect: '/business-trip/workbench' },
  {
    path: '/contracts/:uuid',
    name: 'legacy.contracts.detail',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
  },
  {
    path: '/quotes/:uuid',
    name: 'legacy.quotes.detail',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
  },
  {
    path: '/quote/:uuid',
    name: 'zy-crm.quotes.detail',
    hideInMenu: true,
    parentKeys: ['/quote/my'],
    component: './Navigation/QuoteDetail',
  },
  {
    path: '/callback',
    layout: false,
    component: './callback',
  },
  {
    name: 'login',
    path: '/user/login',
    component: './user/login',
    layout: false,
  },
  {
    path: '/user/access-denied',
    component: './user/access-denied',
    layout: false,
  },
  {
    path: '/invoice/list',
    component: '@/modules/zy-crm/pages/Invoice',
    name: 'zy-crm.invoices',
    access: 'invoices',
    locale: 'menu.zy-crm.invoices',
    icon: 'wallet',
  },
  {
    path: '/workbench/overview',
    name: 'zy-crm.workbench',
    locale: 'menu.zy-crm.workbench.overview',
    icon: 'dashboard',
    component: '@/modules/zy-crm/pages/Dashboard',
  },
  {
    path: '/workbench/approval',
    access: 'approvals',
    name: 'zy-crm.approvals',
    locale: 'menu.zy-crm.approvals',
    icon: 'audit',
    component: '@/modules/zy-crm/pages/ApprovalCenter',
  },
  {
    path: '/workbench/calendar',
    access: 'collaboration-calendar',
    name: 'zy-crm.collaboration.calendar',
    locale: 'menu.zy-crm.collaboration.calendar',
    component: '@/modules/zy-crm/pages/Calendar',
  },
  {
    path: '/workbench/follow-up',
    access: 'collaboration-follow-ups',
    name: 'zy-crm.collaboration.followUps',
    locale: 'menu.zy-crm.collaboration.followUps',
    component: '@/modules/zy-crm/pages/FollowUp',
  },
  {
    path: '/workbench/task',
    access: 'collaboration-tasks',
    name: 'zy-crm.collaboration.tasks',
    locale: 'menu.zy-crm.collaboration.tasks',
    component: '@/modules/zy-crm/pages/Task',
  },
  {
    path: '/workbench/business-trip',
    access: 'business-trips',
    name: '出差助手',
    locale: 'menu.crm.page.business-trip',
    hideInMenu: true,
    component: '@/modules/business-trip/pages/LegacyRedirect',
  },
  {
    path: '/workbench/attachment',
    access: 'collaboration-attachments',
    name: 'zy-crm.collaboration.attachments',
    locale: 'menu.zy-crm.collaboration.attachments',
    component: '@/modules/zy-crm/pages/Attachment',
  },
  {
    path: '/marketing/campaign',
    access: 'marketing-campaigns',
    name: 'zy-crm.marketing.campaigns',
    locale: 'menu.zy-crm.marketing.campaigns',
    component: '@/modules/zy-crm/pages/MarketingCampaign',
  },
  {
    path: '/marketing/campaign/:uuid',
    access: 'marketing-campaign-detail',
    hideInMenu: true,
    parentKeys: ['/marketing/campaign'],
    component: '@/modules/zy-crm/pages/MarketingCampaignDetail',
    name: 'crm.marketing.campaign.uuid',
  },
  {
    path: '/marketing/campaign/:uuid/member',
    access: 'marketing-campaign-members',
    hideInMenu: true,
    parentKeys: ['/marketing/campaign'],
    component: '@/modules/zy-crm/pages/MarketingCampaignMembers',
    name: 'crm.marketing.campaign.uuid.member',
  },
  {
    path: '/marketing/campaign/:uuid/analysis',
    access: 'marketing-campaign-analysis',
    hideInMenu: true,
    parentKeys: ['/marketing/campaign'],
    component: '@/modules/zy-crm/pages/MarketingCampaignAnalysis',
    name: 'crm.marketing.campaign.uuid.analysis',
  },
  {
    path: '/lead/overview',
    access: 'leads-overview',
    name: 'zy-crm.leads.overview',
    locale: 'menu.zy-crm.leads.overview',
    component: '@/modules/zy-crm/pages/LeadOverview',
  },
  {
    path: '/lead/my',
    access: 'leads-my',
    name: 'zy-crm.leads.my',
    locale: 'menu.zy-crm.leads.my',
    component: '@/modules/zy-crm/pages/Lead',
  },
  {
    path: '/lead/team',
    access: 'leads-team',
    name: 'zy-crm.leads.team',
    locale: 'menu.zy-crm.leads.team',
    component: '@/modules/zy-crm/pages/Lead',
  },
  {
    path: '/lead/collab',
    access: 'leads-collab',
    name: 'zy-crm.leads.collab',
    locale: 'menu.zy-crm.leads.collab',
    component: '@/modules/zy-crm/pages/Lead',
  },
  {
    path: '/lead/pool',
    access: 'leads-pool',
    name: 'zy-crm.leads.pool',
    locale: 'menu.zy-crm.leads.pool',
    component: '@/modules/zy-crm/pages/Lead',
  },
  {
    path: '/lead/all',
    access: 'leads-all',
    name: 'zy-crm.leads.all',
    locale: 'menu.zy-crm.leads.all',
    component: '@/modules/zy-crm/pages/Lead',
  },
  {
    path: '/lead/imported',
    access: 'leads-imported',
    name: 'zy-crm.leads.imported',
    locale: 'menu.zy-crm.leads.imported',
    component: '@/modules/zy-crm/pages/Lead',
  },
  {
    path: '/lead/import-conflict',
    access: 'lead-import-conflicts',
    name: 'zy-crm.leads.importConflicts',
    locale: 'menu.zy-crm.leads.importConflicts',
    component: '@/modules/zy-crm/pages/LeadImportConflicts',
  },
  {
    path: '/customer/overview',
    access: 'customers-overview',
    name: 'zy-crm.customers.overview',
    locale: 'menu.zy-crm.customers.overview',
    component: '@/modules/zy-crm/pages/CustomerOverview',
  },
  {
    path: '/customer/my',
    access: 'customers-my',
    name: 'zy-crm.customers.my',
    locale: 'menu.zy-crm.customers.my',
    component: '@/modules/zy-crm/pages/Customer',
  },
  {
    path: '/customer/team',
    access: 'customers-team',
    name: 'zy-crm.customers.team',
    locale: 'menu.zy-crm.customers.team',
    component: '@/modules/zy-crm/pages/Customer',
  },
  {
    path: '/customer/collab',
    access: 'customers-collab',
    name: 'zy-crm.customers.collab',
    locale: 'menu.zy-crm.customers.collab',
    component: '@/modules/zy-crm/pages/Customer',
  },
  {
    path: '/customer/pool',
    access: 'customers-pool',
    name: 'zy-crm.customers.pool',
    locale: 'menu.zy-crm.customers.pool',
    component: '@/modules/zy-crm/pages/Customer',
  },
  {
    path: '/customer/all',
    access: 'customers-all',
    name: 'zy-crm.customers.all',
    locale: 'menu.zy-crm.customers.all',
    component: '@/modules/zy-crm/pages/Customer',
  },
  {
    path: '/contact/overview',
    access: 'contacts-overview',
    name: 'zy-crm.contacts.overview',
    locale: 'menu.zy-crm.contacts.overview',
    component: '@/modules/zy-crm/pages/ContactOverview',
  },
  {
    path: '/contact/my',
    access: 'contacts-my',
    name: 'zy-crm.contacts.my',
    locale: 'menu.zy-crm.contacts.my',
    component: '@/modules/zy-crm/pages/Contact',
  },
  {
    path: '/contact/team',
    access: 'contacts-team',
    name: 'zy-crm.contacts.team',
    locale: 'menu.zy-crm.contacts.team',
    component: '@/modules/zy-crm/pages/Contact',
  },
  {
    path: '/contact/collab',
    access: 'contacts-collab',
    name: 'zy-crm.contacts.collab',
    locale: 'menu.zy-crm.contacts.collab',
    component: '@/modules/zy-crm/pages/Contact',
  },
  {
    path: '/contact/all',
    access: 'contacts-all',
    name: 'zy-crm.contacts.all',
    locale: 'menu.zy-crm.contacts.all',
    component: '@/modules/zy-crm/pages/Contact',
  },
  {
    path: '/opportunity/overview',
    access: 'opportunities-overview',
    name: 'zy-crm.opportunities.overview',
    locale: 'menu.zy-crm.opportunities.overview',
    component: '@/modules/zy-crm/pages/OpportunityOverview',
  },
  {
    path: '/opportunity/my',
    access: 'opportunities-my',
    name: 'zy-crm.opportunities.my',
    locale: 'menu.zy-crm.opportunities.my',
    component: '@/modules/zy-crm/pages/Opportunity',
  },
  {
    path: '/opportunity/followed',
    access: 'opportunities-followed',
    name: 'zy-crm.opportunities.followed',
    locale: 'menu.zy-crm.opportunities.followed',
    component: '@/modules/zy-crm/pages/Opportunity',
  },
  {
    path: '/opportunity/team',
    access: 'opportunities-team',
    name: 'zy-crm.opportunities.team',
    locale: 'menu.zy-crm.opportunities.team',
    component: '@/modules/zy-crm/pages/Opportunity',
  },
  {
    path: '/opportunity/collab',
    access: 'opportunities-collab',
    name: 'zy-crm.opportunities.collab',
    locale: 'menu.zy-crm.opportunities.collab',
    component: '@/modules/zy-crm/pages/Opportunity',
  },
  {
    path: '/opportunity/pool',
    access: 'opportunities-pool',
    name: 'zy-crm.opportunities.pool',
    locale: 'menu.zy-crm.opportunities.pool',
    component: '@/modules/zy-crm/pages/Opportunity',
  },
  {
    path: '/opportunity/all',
    access: 'opportunities-all',
    name: 'zy-crm.opportunities.all',
    locale: 'menu.zy-crm.opportunities.all',
    component: '@/modules/zy-crm/pages/Opportunity',
  },
  {
    path: '/quote/my',
    access: 'quotes-my',
    name: 'zy-crm.quotes.my',
    locale: 'menu.zy-crm.quotes.my',
    component: '@/modules/zy-crm/pages/Quote',
  },
  {
    path: '/quote/team',
    access: 'quotes-team',
    name: 'zy-crm.quotes.team',
    locale: 'menu.zy-crm.quotes.team',
    component: '@/modules/zy-crm/pages/Quote',
  },
  {
    path: '/quote/collab',
    access: 'quotes-collab',
    name: 'zy-crm.quotes.collab',
    locale: 'menu.zy-crm.quotes.collab',
    component: '@/modules/zy-crm/pages/Quote',
  },
  {
    path: '/quote/all',
    access: 'quotes-all',
    name: 'zy-crm.quotes.all',
    locale: 'menu.zy-crm.quotes.all',
    component: '@/modules/zy-crm/pages/Quote',
  },
  {
    path: '/contract/my',
    access: 'contracts-my',
    name: 'zy-crm.contracts.my',
    locale: 'menu.zy-crm.contracts.my',
    component: '@/modules/zy-crm/pages/Contract',
  },
  {
    path: '/contract/team',
    access: 'contracts-team',
    name: 'zy-crm.contracts.team',
    locale: 'menu.zy-crm.contracts.team',
    component: '@/modules/zy-crm/pages/Contract',
  },
  {
    path: '/contract/collab',
    access: 'contracts-collab',
    name: 'zy-crm.contracts.collab',
    locale: 'menu.zy-crm.contracts.collab',
    component: '@/modules/zy-crm/pages/Contract',
  },
  {
    path: '/contract/all',
    access: 'contracts-all',
    name: 'zy-crm.contracts.all',
    locale: 'menu.zy-crm.contracts.all',
    component: '@/modules/zy-crm/pages/Contract',
  },
  {
    path: '/receipt/list',
    access: 'receipts-list',
    name: 'zy-crm.receipts.list',
    locale: 'menu.zy-crm.receipts.list',
    component: '@/modules/zy-crm/pages/Receipt',
  },
  {
    path: '/receipt/schedule',
    access: 'receipts-schedules',
    name: 'zy-crm.receipts.schedules',
    locale: 'menu.zy-crm.receipts.schedules',
    component: '@/modules/zy-crm/pages/ReceiptSchedule',
  },
  {
    path: '/receipt/schedule/:uuid',
    access: 'receipts-schedule-detail',
    name: 'zy-crm.receipts.schedules.detail',
    locale: 'menu.zy-crm.receipts.schedules.detail',
    hideInMenu: true,
    parentKeys: ['/receipt/schedule'],
    component: '@/modules/zy-crm/pages/ReceiptScheduleDetail',
  },
  {
    path: '/performance/overview',
    name: 'crm.performance.overview',
    locale: 'menu.crm.performance.overview',
    access: 'performance-overview',
    component: '@/modules/zy-crm/pages/Performance',
  },
  {
    path: '/performance/targets',
    name: 'crm.performance.targets',
    locale: 'menu.crm.performance.targets',
    access: 'performance-targets',
    component: '@/modules/zy-crm/pages/Performance',
  },
  {
    path: '/performance/entries',
    name: 'crm.performance.entries',
    locale: 'menu.crm.performance.entries',
    access: 'performance-entries',
    component: '@/modules/zy-crm/pages/Performance',
  },
  {
    path: '/performance/splits',
    name: 'crm.performance.splits',
    locale: 'menu.crm.performance.splits',
    access: 'performance-splits',
    component: '@/modules/zy-crm/pages/Performance',
  },
  {
    path: '/performance/team',
    name: 'crm.performance.team',
    locale: 'menu.crm.performance.team',
    access: 'performance-team',
    component: '@/modules/zy-crm/pages/Performance',
  },
  {
    path: '/performance/reconciliation',
    name: 'crm.performance.reconciliation',
    locale: 'menu.crm.performance.reconciliation',
    access: 'performance-reconciliation',
    component: '@/modules/zy-crm/pages/Performance',
  },
  {
    path: '/analysis/business',
    name: 'zy-crm.analytics.business',
    locale: 'menu.zy-crm.analytics.business',
    component: '@/modules/zy-crm/pages/DashboardAnalysis',
  },
  {
    path: '/analysis/customer',
    name: 'zy-crm.analytics.customer',
    locale: 'menu.zy-crm.analytics.customer',
    component: '@/modules/zy-crm/pages/DashboardAnalysis',
  },
  {
    path: '/analysis/sales',
    name: 'zy-crm.analytics.sales',
    locale: 'menu.zy-crm.analytics.sales',
    component: '@/modules/zy-crm/pages/DashboardAnalysis',
  },
  {
    path: '/analysis/performance',
    name: 'zy-crm.analytics.performance',
    locale: 'menu.zy-crm.analytics.performance',
    component: '@/modules/zy-crm/pages/DashboardAnalysis',
  },
  {
    path: '/analysis/product',
    name: 'zy-crm.analytics.product',
    locale: 'menu.zy-crm.analytics.product',
    component: '@/modules/zy-crm/pages/DashboardAnalysis',
  },
  {
    path: '/analysis/lead-source',
    access: 'analytics-lead-source',
    name: 'zy-crm.analytics.leadSource',
    locale: 'menu.zy-crm.analytics.leadSource',
    component: '@/modules/zy-crm/pages/LeadSourceAnalysis',
  },
  {
    path: '/analysis/business-map',
    access: 'analytics-business-map',
    name: 'zy-crm.analytics.businessMap',
    locale: 'menu.zy-crm.analytics.businessMap',
    component: '@/modules/zy-crm/pages/business-map',
  },
  {
    path: '/analysis/governance',
    access: 'analytics-governance',
    name: 'zy-crm.analytics.governance',
    locale: 'menu.zy-crm.analytics.governance',
    component: '@/modules/zy-crm/pages/Governance',
  },
  {
    path: '/setting/business-trip/close-reasons',
    access: 'business-trips:manage-close-reasons',
    hideInMenu: true,
    parentKeys: ['/setting'],
    component: '@/modules/zy-crm/pages/SystemConfig',
    name: 'crm.setting.businessTrip.closeReasons',
  },
  {
    path: '/setting/general/taxonomy',
    access: 'settings-taxonomies',
    hideInMenu: true,
    parentKeys: ['/setting'],
    component: '@/modules/zy-crm/pages/SystemConfig',
    name: 'crm.setting.general.taxonomies',
  },
  {
    path: '/setting/general/permission',
    access: 'settings-permissions',
    hideInMenu: true,
    name: 'zy-crm.settings.general.permissions',
    locale: 'menu.zy-crm.systemConfig.permissions',
    component: '@/modules/zy-crm/pages/SystemConfig',
    parentKeys: ['/setting'],
  },
  {
    path: '/setting/general/automation-rule',
    access: 'settings-automation-rules',
    hideInMenu: true,
    parentKeys: ['/setting'],
    component: '@/modules/zy-crm/pages/SystemConfig',
    name: 'crm.setting.general.automation-rule',
  },
  {
    path: '/setting/general/workflow-approval',
    access: 'settings-workflow-approval',
    hideInMenu: true,
    parentKeys: ['/setting'],
    component: '@/modules/zy-crm/pages/SystemConfig',
    name: 'crm.setting.general.workflow-approval',
  },
  {
    path: '/setting/general/invoice-profile',
    access: 'settings-invoice-profile',
    hideInMenu: true,
    parentKeys: ['/setting'],
    component: '@/modules/zy-crm/pages/SystemConfig',
    name: 'crm.setting.general.invoice-profile',
  },
  {
    path: '/setting/general/tavily',
    access: 'modelSettings',
    hideInMenu: true,
    parentKeys: ['/setting'],
    component: '@/modules/zy-crm/pages/SystemConfig',
    name: 'crm.setting.general.tavily',
  },
  {
    path: '/setting/general/ai-model-binding',
    access: 'modelSettings',
    hideInMenu: true,
    parentKeys: ['/setting'],
    component: '@/modules/zy-crm/pages/SystemConfig',
    name: 'crm.setting.general.ai-model-binding',
  },
  {
    path: '/setting/general/dictionary',
    access: 'settings-dictionaries',
    hideInMenu: true,
    parentKeys: ['/setting'],
    component: '@/modules/zy-crm/pages/SystemConfig',
    name: 'crm.setting.general.dictionary',
  },
  {
    path: '/setting/general/dictionary/:dictionaryCode/item',
    access: 'settings-dictionary-items',
    hideInMenu: true,
    parentKeys: ['/setting'],
    component: '@/modules/zy-crm/pages/DictionaryManagement',
    name: 'crm.setting.general.dictionary.dictionaryCode.item',
  },
  {
    path: '/setting/lead/pool',
    access: 'settings-lead-pool',
    hideInMenu: true,
    parentKeys: ['/setting'],
    component: '@/modules/zy-crm/pages/SystemConfig',
    name: 'crm.setting.lead.pool',
  },
  {
    path: '/setting/lead/assign-rule',
    access: 'settings-lead-assign-rules',
    hideInMenu: true,
    parentKeys: ['/setting'],
    component: '@/modules/zy-crm/pages/SystemConfig',
    name: 'crm.setting.lead.assign-rule',
  },
  {
    path: '/setting/lead/industry',
    access: 'settings-industries',
    hideInMenu: true,
    parentKeys: ['/setting'],
    component: '@/modules/zy-crm/pages/SystemConfig',
    name: 'crm.setting.lead.industry',
  },
  {
    path: '/setting/lead/area',
    access: 'settings-areas',
    hideInMenu: true,
    parentKeys: ['/setting'],
    component: '@/modules/zy-crm/pages/SystemConfig',
    name: 'crm.setting.lead.area',
  },
  {
    path: '/setting/customer/pool',
    access: 'settings-customer-pool',
    hideInMenu: true,
    parentKeys: ['/setting'],
    component: '@/modules/zy-crm/pages/SystemConfig',
    name: 'crm.setting.customer.pool',
  },
  {
    path: '/setting/customer/limit',
    access: 'settings-customer-limits',
    hideInMenu: true,
    parentKeys: ['/setting'],
    component: '@/modules/zy-crm/pages/SystemConfig',
    name: 'crm.setting.customer.limit',
  },
  {
    path: '/setting/customer/source-channel',
    access: 'settings-source-channels',
    hideInMenu: true,
    parentKeys: ['/setting'],
    component: '@/modules/zy-crm/pages/SystemConfig',
    name: 'crm.setting.customer.source-channel',
  },
  {
    path: '/setting/customer/level',
    access: 'settings-customer-levels',
    hideInMenu: true,
    parentKeys: ['/setting'],
    component: '@/modules/zy-crm/pages/SystemConfig',
    name: 'crm.setting.customer.level',
  },
  {
    path: '/setting/opportunity/pipeline',
    access: 'settings-opportunity-pipelines',
    hideInMenu: true,
    parentKeys: ['/setting'],
    component: '@/modules/zy-crm/pages/SystemConfig',
    name: 'crm.setting.opportunity.pipeline',
  },
  {
    path: '/setting/opportunity/stage',
    access: 'settings-opportunity-stages',
    hideInMenu: true,
    parentKeys: ['/setting'],
    component: '@/modules/zy-crm/pages/SystemConfig',
    name: 'crm.setting.opportunity.stage',
  },
  {
    path: '/setting/marketing/campaign-type',
    access: 'settings-marketing-campaign-types',
    hideInMenu: true,
    parentKeys: ['/setting'],
    component: '@/modules/zy-crm/pages/SystemConfig',
    name: 'crm.setting.marketing.campaign-type',
  },
  {
    path: '/setting/marketing/touchpoint-type',
    access: 'settings-marketing-touchpoint-types',
    hideInMenu: true,
    parentKeys: ['/setting'],
    component: '@/modules/zy-crm/pages/SystemConfig',
    name: 'crm.setting.marketing.touchpoint-type',
  },
  {
    path: '/setting/contract/config',
    access: 'settings-contract-config',
    hideInMenu: true,
    parentKeys: ['/setting'],
    component: '@/modules/zy-crm/pages/SystemConfig',
    name: 'crm.setting.contract.config',
  },
  {
    path: '/setting/contract/code-rule',
    access: 'settings-contract-code-rules',
    hideInMenu: true,
    parentKeys: ['/setting'],
    component: '@/modules/zy-crm/pages/SystemConfig',
    name: 'crm.setting.contract.code-rule',
  },
  {
    path: '/product/catalog',
    name: 'zy-crm.products.catalog',
    locale: 'menu.zy-crm.products.catalog',
    component: '@/modules/zy-crm/pages/ProductCatalog',
  },
  {
    path: '/product/version/:versionUuid',
    name: 'zy-crm.products.detail',
    hideInMenu: true,
    parentKeys: ['/product/catalog'],
    component: '@/modules/zy-crm/pages/ProductVersion',
  },
  {
    path: '/dashboard',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.dashboard',
  },
  {
    path: '/calendar',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.calendar',
  },
  {
    path: '/follow-ups',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.follow-ups',
  },
  {
    path: '/tasks',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.tasks',
  },
  {
    path: '/attachments',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.attachments',
  },
  {
    path: '/leads',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.leads',
  },
  {
    path: '/customers',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.customers',
  },
  {
    path: '/contact',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.contact',
  },
  {
    path: '/opportunities',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.opportunities',
  },
  {
    path: '/quote',
    hideInMenu: true,
    component: './Navigation/ModuleRedirect',
    name: 'legacy.quote',
  },
  {
    path: '/contract',
    hideInMenu: true,
    component: './Navigation/ModuleRedirect',
    name: 'legacy.contract',
  },
  {
    path: '/contract/:uuid',
    hideInMenu: true,
    component: './Navigation/ContractDetail',
    name: 'zy-crm.contracts.detail',
    parentKeys: ['/contract/my'],
  },
  {
    path: '/invoice/profile',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.invoice.profile',
  },
  {
    path: '/lead-source-analysis',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.lead-source-analysis',
  },
  {
    path: '/governance',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.governance',
  },
  {
    path: '/system-config',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.system-config',
  },
  {
    path: '/permissions',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.permissions',
  },
  {
    path: '/automation-rules',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.automation-rules',
  },
  {
    path: '/customer-pool-configs',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.customer-pool-configs',
  },
  {
    path: '/lead-pool-configs',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.lead-pool-configs',
  },
  {
    path: '/lead-assign-rules',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.lead-assign-rules',
  },
  {
    path: '/customer-limit-configs',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.customer-limit-configs',
  },
  {
    path: '/owner-limit-configs',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.owner-limit-configs',
  },
  {
    path: '/source-channels',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.source-channels',
  },
  {
    path: '/opportunity-pipelines',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.opportunity-pipelines',
  },
  {
    path: '/opportunity-stages',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.opportunity-stages',
  },
  {
    path: '/areas',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.areas',
  },
  {
    path: '/industries',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.industries',
  },
  {
    path: '/contract-configs',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.contract-configs',
  },
  {
    path: '/contract-code-rules',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.contract-code-rules',
  },
  {
    path: '/system-config/general/permissions',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.system-config.general.permissions',
  },
  {
    path: '/system-config/general/automation-rules',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.system-config.general.automation-rules',
  },
  {
    path: '/system-config/general/workflow-approval',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.system-config.general.workflow-approval',
  },
  {
    path: '/system-config/general/invoice-profile',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.system-config.general.invoice-profile',
  },
  {
    path: '/system-config/general/dictionaries',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.system-config.general.dictionaries',
  },
  {
    path: '/system-config/dictionaries',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.system-config.dictionaries',
  },
  {
    path: '/system-config/lead/pool',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.system-config.lead.pool',
  },
  {
    path: '/system-config/lead/assign-rules',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.system-config.lead.assign-rules',
  },
  {
    path: '/system-config/lead/industries',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.system-config.lead.industries',
  },
  {
    path: '/system-config/lead/areas',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.system-config.lead.areas',
  },
  {
    path: '/system-config/customer/pool',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.system-config.customer.pool',
  },
  {
    path: '/system-config/customer/source-channels',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.system-config.customer.source-channels',
  },
  {
    path: '/system-config/customer/levels',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.system-config.customer.levels',
  },
  {
    path: '/system-config/customer/limits',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.system-config.customer.limits',
  },
  {
    path: '/system-config/opportunity/pipelines',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.system-config.opportunity.pipelines',
  },
  {
    path: '/system-config/opportunity/stages',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.system-config.opportunity.stages',
  },
  {
    path: '/system-config/contract/config',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.system-config.contract.config',
  },
  {
    path: '/system-config/contract/code-rules',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.system-config.contract.code-rules',
  },
  {
    path: '/system-config/customer-pool-configs',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.system-config.customer-pool-configs',
  },
  {
    path: '/system-config/lead-pool-configs',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.system-config.lead-pool-configs',
  },
  {
    path: '/system-config/lead-assign-rules',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.system-config.lead-assign-rules',
  },
  {
    path: '/system-config/customer-limit-configs',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.system-config.customer-limit-configs',
  },
  {
    path: '/system-config/owner-limit-configs',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.system-config.owner-limit-configs',
  },
  {
    path: '/system-config/opportunity-pipelines',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.system-config.opportunity-pipelines',
  },
  {
    path: '/system-config/opportunity-stages',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.system-config.opportunity-stages',
  },
  {
    path: '/system-config/areas',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.system-config.areas',
  },
  {
    path: '/system-config/source-channels',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.system-config.source-channels',
  },
  {
    path: '/system-config/customer-levels',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.system-config.customer-levels',
  },
  {
    path: '/system-config/industries',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.system-config.industries',
  },
  {
    path: '/system-config/contract-configs',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.system-config.contract-configs',
  },
  {
    path: '/system-config/contract-code-rules',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.system-config.contract-code-rules',
  },
  {
    path: '/workbench',
    hideInMenu: true,
    component: './Navigation/ModuleRedirect',
    name: 'legacy.workbench',
  },
  {
    path: '/approvals',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.approvals',
  },
  {
    path: '/collaboration/calendar',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.collaboration.calendar',
  },
  {
    path: '/collaboration/follow-ups',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.collaboration.follow-ups',
  },
  {
    path: '/collaboration/tasks',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.collaboration.tasks',
  },
  {
    path: '/collaboration/attachments',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.collaboration.attachments',
  },
  {
    path: '/marketing',
    hideInMenu: true,
    component: './Navigation/ModuleRedirect',
    name: 'legacy.marketing',
  },
  {
    path: '/marketing/campaigns',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.marketing.campaigns',
  },
  {
    path: '/marketing/campaigns/:uuid',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.marketing.campaigns.:uuid',
  },
  {
    path: '/marketing/campaigns/:uuid/members',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.marketing.campaigns.:uuid.members',
  },
  {
    path: '/marketing/campaigns/:uuid/analysis',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.marketing.campaigns.:uuid.analysis',
  },
  {
    path: '/leads/my',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.leads.my',
  },
  {
    path: '/leads/team',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.leads.team',
  },
  {
    path: '/leads/collab',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.leads.collab',
  },
  {
    path: '/leads/pool',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.leads.pool',
  },
  {
    path: '/leads/all',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.leads.all',
  },
  {
    path: '/leads/imported',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.leads.imported',
  },
  {
    path: '/leads/import-conflicts',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.leads.import-conflicts',
  },
  {
    path: '/customers/my',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.customers.my',
  },
  {
    path: '/customers/team',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.customers.team',
  },
  {
    path: '/customers/collab',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.customers.collab',
  },
  {
    path: '/customers/pool',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.customers.pool',
  },
  {
    path: '/customers/all',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.customers.all',
  },
  {
    path: '/contacts',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.contacts',
  },
  {
    path: '/contacts/my',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.contacts.my',
  },
  {
    path: '/contacts/team',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.contacts.team',
  },
  {
    path: '/contacts/collab',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.contacts.collab',
  },
  {
    path: '/contacts/all',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.contacts.all',
  },
  {
    path: '/opportunities/my',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.opportunities.my',
  },
  {
    path: '/opportunities/followed',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.opportunities.followed',
  },
  {
    path: '/opportunities/team',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.opportunities.team',
  },
  {
    path: '/opportunities/collab',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.opportunities.collab',
  },
  {
    path: '/opportunities/pool',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.opportunities.pool',
  },
  {
    path: '/opportunities/all',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.opportunities.all',
  },
  {
    path: '/quotes',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.quotes',
  },
  {
    path: '/quotes/my',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.quotes.my',
  },
  {
    path: '/quotes/team',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.quotes.team',
  },
  {
    path: '/quotes/collab',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.quotes.collab',
  },
  {
    path: '/quotes/all',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.quotes.all',
  },
  {
    path: '/contracts',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.contracts',
  },
  {
    path: '/contracts/my',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.contracts.my',
  },
  {
    path: '/contracts/team',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.contracts.team',
  },
  {
    path: '/contracts/collab',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.contracts.collab',
  },
  {
    path: '/contracts/all',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.contracts.all',
  },
  {
    path: '/receipts/list',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.receipts.list',
  },
  {
    path: '/receipts/schedules',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.receipts.schedules',
  },
  {
    path: '/receipts/schedules/:uuid',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.receipts.schedules.:uuid',
  },
  {
    path: '/invoices/list',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.invoices.list',
  },
  {
    path: '/analytics/lead-source',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.analytics.lead-source',
  },
  {
    path: '/analytics/business-map',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.analytics.business-map',
  },
  {
    path: '/analytics/governance',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.analytics.governance',
  },
  {
    path: '/settings',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.settings',
  },
  {
    path: '/settings/general/taxonomies',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.settings.general.taxonomies',
  },
  {
    path: '/settings/general/permissions',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.settings.general.permissions',
  },
  {
    path: '/settings/general/automation-rules',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.settings.general.automation-rules',
  },
  {
    path: '/settings/general/workflow-approval',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.settings.general.workflow-approval',
  },
  {
    path: '/settings/general/invoice-profile',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.settings.general.invoice-profile',
  },
  {
    path: '/settings/general/ai-model-binding',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.settings.general.ai-model-binding',
  },
  {
    path: '/settings/general/dictionaries',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.settings.general.dictionaries',
  },
  {
    path: '/settings/general/dictionaries/:dictionaryCode/items',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.settings.general.dictionaries.:dictionaryCode.items',
  },
  {
    path: '/settings/lead/pool',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.settings.lead.pool',
  },
  {
    path: '/settings/lead/assign-rules',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.settings.lead.assign-rules',
  },
  {
    path: '/settings/lead/industries',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.settings.lead.industries',
  },
  {
    path: '/settings/lead/areas',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.settings.lead.areas',
  },
  {
    path: '/settings/customer/pool',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.settings.customer.pool',
  },
  {
    path: '/settings/customer/limits',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.settings.customer.limits',
  },
  {
    path: '/settings/customer/source-channels',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.settings.customer.source-channels',
  },
  {
    path: '/settings/customer/levels',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.settings.customer.levels',
  },
  {
    path: '/settings/opportunity/pipelines',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.settings.opportunity.pipelines',
  },
  {
    path: '/settings/opportunity/stages',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.settings.opportunity.stages',
  },
  {
    path: '/settings/marketing/campaign-types',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.settings.marketing.campaign-types',
  },
  {
    path: '/settings/marketing/touchpoint-types',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.settings.marketing.touchpoint-types',
  },
  {
    path: '/settings/contract/config',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.settings.contract.config',
  },
  {
    path: '/settings/contract/code-rules',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.settings.contract.code-rules',
  },
  {
    path: '/',
    hideInMenu: true,
    component: './Navigation/LegacyRedirect',
    name: 'legacy.',
  },
  {
    path: '/lead',
    hideInMenu: true,
    component: './Navigation/ModuleRedirect',
    name: 'entry.lead',
  },
  {
    path: '/customer',
    hideInMenu: true,
    component: './Navigation/ModuleRedirect',
    name: 'entry.customer',
  },
  {
    path: '/opportunity',
    hideInMenu: true,
    component: './Navigation/ModuleRedirect',
    name: 'entry.opportunity',
  },
  {
    path: '/product',
    hideInMenu: true,
    component: './Navigation/ModuleRedirect',
    name: 'entry.product',
  },
  {
    path: '/receipt',
    hideInMenu: true,
    component: './Navigation/ModuleRedirect',
    name: 'entry.receipt',
  },
  {
    path: '/performance',
    hideInMenu: true,
    component: './Navigation/ModuleRedirect',
    name: 'entry.performance',
  },
  {
    path: '/analysis',
    hideInMenu: true,
    component: './Navigation/ModuleRedirect',
    name: 'entry.analysis',
  },
  {
    path: '/setting',
    hideInMenu: true,
    component: './Navigation/ModuleRedirect',
    name: 'entry.setting',
  },
  {
    path: '*',
    layout: false,
    component: './404',
  },
];
